import { Screen } from '@/components/layout/Screen';

import { FooterSection } from './FooterSection';
import { PreferencesSection } from './PreferencesSection';
import { StaffSection } from './StaffSection';

/**
 * メール設定ページ。
 *
 * v3.3.2: 送信元メールアカウント (MailAccountsSection) は
 * システム > 全体設定 > ② 通知 > メール管理 へ移動。
 * v3.3.x: 会社情報 (CompanySection) は システム > 一般設定 へ移動。
 */
export function MailSettingsPage() {
  return (
    <Screen
      title="メール設定"
      description="担当者・フッターなど、メール生成と表記に関わる設定を管理します"
    >
      <div className="max-w-3xl">
        <StaffSection />
        <FooterSection />
        <PreferencesSection />
      </div>
    </Screen>
  );
}
